import { render, staticRenderFns } from "./ServiseSection.vue?vue&type=template&id=be432762"
import script from "./ServiseSection.vue?vue&type=script&lang=js"
export * from "./ServiseSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports